import { Field } from 'redux-form'


const adaptFileEventToValue = delegate => e => delegate(e.target.files[0])

const FileInput = ({
  input: { onChange, onBlur, value },
  ...props
}) => (
  <div className="file has-name is-boxed is-small">
    <label className="file-label">
      <input
        onChange={adaptFileEventToValue(onChange)}
        onBlur={adaptFileEventToValue(onBlur)}
        type="file"
        {...props.input}
        {...props}
      />
      <span className="file-cta">
        <span className="file-icon">
          <i className="fas fa-upload" />
        </span>
        <span className="file-label">
          Choose a file…
        </span>
      </span>
      <span className="file-name">
        { value ? value.name : 'No file selected' }
      </span>
    </label>
  </div>
  )

const FileSelect = props => (
  <Field
    type="file"
    id={props.id}
    name={props.name}
    component={FileInput}
    className="file-input"
    {...props} />

)

export default FileSelect



// WEBPACK FOOTER //
// ./components/uiLib/FileSelect/index.js